import React from 'react';
import { createRoot } from 'react-dom/client';
import AddonComponent from './components/SearchSpring/AddOnList';

function SearchSpringCartRecs() {
  const configEl = document.getElementById('react-searchspring-config');
  const siteId = configEl?.dataset.siteId;

  const headerElement = document.querySelector('header');
  const locale = headerElement?.getAttribute('data-locale') || 'en_US';
  let searchProfile = 'us-mini-cart';

  if (locale.includes('US')) {
    searchProfile = 'us-mini-cart';
  } else {
    searchProfile = 'emea-mini-cart';
  }

  if (!siteId) {
    return null;
  }

  return <AddonComponent profile={searchProfile} subtitle='Frequently Bought Together' />;
}

export function mountSearchSpringCartRecs() {
  const rootEl = document.getElementById('search-spring-cart-recs');
  if (!rootEl) return;
  createRoot(rootEl).render(<SearchSpringCartRecs />);
}

fetch('/cart.js')
  .then((res) => res.json())
  .then((cartData) => {
    if (cartData.item_count > 0) {
      mountSearchSpringCartRecs();
    } else {
      const recsDiv = document.getElementById('search-spring-cart-recs');
      if (recsDiv) {
        recsDiv.innerHTML = '';
      }
    }
  })
  .catch((err) => {
    console.error('Error fetching cart data:', err);
  });
declare global {
  interface Window {
    mountSearchSpringCartRecs: () => void;
  }
}

window.mountSearchSpringCartRecs = mountSearchSpringCartRecs;
